<template>
  <component
    :is="tag"
    :class="computedClass"
    @dragover.prevent="onDragOver"
    @dragenter.prevent="onDragEnter"
    @dragleave="onDragLeave"
    @drop.prevent="onDrop"
  >
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: 'DropZone',
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  },
  data() {
    return {
      isDragOver: false
    };
  },
  computed: {
    computedClass() {
      return {
        'drop-over': this.isDragOver
      };
    }
  },
  methods: {
    onDragOver() {
      this.isDragOver = true;
    },
    onDragEnter() {
      this.isDragOver = true;
    },
    onDragLeave(e) {
      // Only set to false if we're actually leaving the drop zone
      const related = e && e.relatedTarget;
      if (!related || !this.$el.contains(related)) {
        this.isDragOver = false;
      }
    },
    onDrop(e) {
      this.isDragOver = false;
      let data = null;
      const dragId = e.dataTransfer.getData('text/drag-id');
      if (dragId && window.__dragTransferDataMap && window.__dragTransferDataMap[dragId]) {
        data = window.__dragTransferDataMap[dragId];
      }
      if (data == null) {
        try {
          const jsonData = e.dataTransfer.getData('application/json');
          if (jsonData) {
            data = JSON.parse(jsonData);
          }
        } catch (err) {
          // silently ignore parse failures
        }
      }
      if (data == null) {
        return;
      }
      this.$emit('drop', data, e);
    }
  }
};
</script>
